/**
 * The integrations service is hosted on a subdomain which marketplace-web connects to directly.
 * PR environments use the dev build, but devs often times use them with the staging api.
 * Because of this, we need to dynamically map the integrations service url based on the current environment
 * to avoid auth0 errors between marketplace BE and integrations service.
 */
export default function getIntegrationsServiceUrl(): string {
  if (import.meta.env.MODE === 'test') {
    return 'http://localhost:3000';
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost') {
    return 'http://localhost:8399';
  }

  if (hostname.includes('app')) {
    return hostname.replace('app', 'https://connections');
  }

  if (hostname.includes('dev.leaflink.io')) {
    return 'https://connections.dev.leaflink.io';
  }

  if (hostname.includes('demo')) {
    return `https://connections.${hostname}`;
  }

  return '';
}
